import { Component, OnInit, EventEmitter } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivityService } from '../../common/activity.service';

@Component({
  selector: 'activity-question-form',
  templateUrl: './activity-question-form.component.html',
  styleUrls: ['./activity-question-form.component.css', '../../app.component.css'],
  providers: [ActivityService]
})
export class ActivityQuestionFormComponent implements OnInit {

 eventId: any;
 activityId: any;
 activityQuestionForm: any;
 activityQuestionId: any;
 activityQuestion: any;
 spinner:boolean = false;

 constructor(private formBuilder: FormBuilder, private activityService: ActivityService){
  this.activityQuestionForm = this.formBuilder.group({
   'id': [''],
   'question': ['', Validators.required],
   'answerType': ['', Validators.required],
   'parentOptionId': [0]
  });
  this.activityQuestion = this.activityQuestionForm.value;
 }

 ngOnInit() {
 }

 onSave = new EventEmitter();

 saveActivityQuestion() {
  if(this.activityQuestionForm.valid)
  {
   this.spinner = true;
   var params = this.activityQuestionForm.value;
   params.activityId = this.activityId;
   params.activityQuestionId = this.activityQuestionId;
   this.activityService.saveActivityQuestion(params).subscribe(
    response => {
     this.spinner = false;
     if(response.status)
     this.onSave.emit();
    },
    error => {
     this.spinner = false;
    }
   );
  }
 }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/activity-question-form/activity-question-form.component.ts